/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_EnabledInputs */

const cs_portals_enabled = /** @type {(inputs: Portals_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapnuto`)
};

const en_portals_enabled = /** @type {(inputs: Portals_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Portals_EnabledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_enabled = /** @type {((inputs?: Portals_EnabledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_EnabledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_enabled(inputs)
	return cs_portals_enabled(inputs)
});